import React from 'react';
import AIChat from './AIChat';
import { isAIConsultantChatEnabled } from '../lib/aiChatFlag';

/** Рендерит AIChat только если не отключено переменной окружения при сборке */
export default function ConsultantChatGate() {
  if (!isAIConsultantChatEnabled()) {
    return null;
  }
  return <AIChat />;
}
